/**
 * Banner/sign PDPs: Width × Height inches drive the hidden Size (ft) variant.
 */
(function () {
  var FT_RE = /(\d+(?:\.\d+)?)\s*['′ft]?\s*[x×]\s*(\d+(?:\.\d+)?)/i;

  function parseFt(label) {
    if (!label) return null;
    var m = String(label).replace(/\s+/g, "").match(FT_RE);
    if (!m) return null;
    return { label: label, w: parseFloat(m[1]) * 12, h: parseFloat(m[2]) * 12 };
  }

  function covers(opt, w, h) {
    return (opt.w + 0.05 >= w && opt.h + 0.05 >= h) || (opt.w + 0.05 >= h && opt.h + 0.05 >= w);
  }

  function pick(opts, w, h) {
    var fit = [];
    for (var i = 0; i < opts.length; i++) {
      if (covers(opts[i], w, h)) fit.push(opts[i]);
    }
    if (fit.length) {
      fit.sort(function (a, b) { return a.w * a.h - b.w * b.h; });
      return fit[0];
    }
    var copy = opts.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; });
    return copy[0] || null;
  }

  function num(el, fallback) {
    var n = parseFloat(el && el.value);
    return isFinite(n) ? n : fallback;
  }

  function clampDefault(el, want) {
    if (!el) return;
    var min = parseFloat(el.getAttribute("min"));
    var max = parseFloat(el.getAttribute("max"));
    if (!isFinite(min)) min = want;
    if (!isFinite(max)) max = want;
    if (want >= min && want <= max) el.value = String(want);
  }

  function init(root) {
    var wIn = root.querySelector('input[name="properties[Width]"]');
    var hIn = root.querySelector('input[name="properties[Height]"]');
    var sizeSelect =
      root.querySelector("[data-ezink-banner-size-select]") ||
      root.querySelector(".product-form__item--size-dropdown .single-option-selector");
    if (!wIn || !hIn) return;

    clampDefault(wIn, 24);
    clampDefault(hIn, 48);

    var opts = [];
    if (sizeSelect) {
      for (var i = 0; i < sizeSelect.options.length; i++) {
        var parsed = parseFt(sizeSelect.options[i].value);
        if (parsed) opts.push(parsed);
      }
      var maxW = 0;
      var maxH = 0;
      for (var j = 0; j < opts.length; j++) {
        maxW = Math.max(maxW, opts[j].w, opts[j].h);
        maxH = Math.max(maxH, opts[j].w, opts[j].h);
      }
      if (maxW > 0) {
        wIn.setAttribute("max", String(maxW));
        var hintW = wIn.parentElement && wIn.parentElement.querySelector(".ezink-art-item__hint");
        if (hintW) hintW.textContent = wIn.min + '" – ' + maxW + '"';
      }
      if (maxH > 0) {
        hIn.setAttribute("max", String(maxH));
        var hintH = hIn.parentElement && hIn.parentElement.querySelector(".ezink-art-item__hint");
        if (hintH) hintH.textContent = hIn.min + '" – ' + maxH + '"';
      }
    }

    function sync() {
      var w = num(wIn, 0);
      var h = num(hIn, 0);
      if (w <= 0 || h <= 0 || !sizeSelect || !opts.length) return;
      var chosen = pick(opts, w, h);
      if (!chosen) return;
      if (sizeSelect.value !== chosen.label) {
        sizeSelect.value = chosen.label;
        sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    wIn.addEventListener("input", sync);
    wIn.addEventListener("change", sync);
    hIn.addEventListener("input", sync);
    hIn.addEventListener("change", sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-section-type="product"]').forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
